module.exports = __webpack_public_path__ + "img/map_bg.233da72b.png";